/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AzureConfig, SearchProperties, FilterFields } from 'src/app/models/env-settings.model';
import { Report, TaxReportData } from 'src/app/models/report.model';
import { FrontEndConfig } from 'src/app/models/index';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Promise } from 'es6-promise'

@Injectable({
  providedIn: 'root'
})
export class EnvSettingsService {
  private config: FrontEndConfig = new FrontEndConfig();
  cssRootUrl: string;
  webApiHost: string;
  maxClientSearchResults: number;
  minPeriodEndYear: number;
  evsUserGuideName: string;
  supportMail: any;
  supportMailTax: any;

  azure: AzureConfig;
  hostname: string;
  filterFields: FilterFields;
  evsReports: Report[] = [];
  taxReports: TaxReportData[] = [];
  cacheSetup: boolean = false;
  adminCacheSetup: boolean = false;

  constructor(private http: HttpClient) {
    this.cssRootUrl = environment.cssRootUrl;
    this.hostname = environment.hostname;
    // verify the change
    this.maxClientSearchResults = environment.maxClientSearchResults;
    this.minPeriodEndYear = environment.minPeriodEndYear;
    this.filterFields = environment.filterFields;
    this.evsReports = environment.EVSReports;
    this.taxReports = environment.TAXReports;
    this.supportMail = environment.supportMail;
    this.supportMailTax = environment.supportMailTax;
    this.webApiHost=environment.webApiHost;

    // Get App Hosting details
    this.azure = new AzureConfig();
    this.azure.isCloud = environment.azure.isCloud.toLowerCase() === 'true';
    this.azure.clientId = environment.azure.clientId;
    this.azure.tenant = environment.azure.tenant;
    this.azure.endpoints = environment.azure.endpoints;
    this.config.azureAd = this.azure;
    this.config.apiUrl = environment.apiUrl,
    this.config.apiBaseUrl = environment.apiBaseUrl,
    this.config.preservationDays = environment.preservationDays,
    this.config.enableTax = environment.enableTax
  }
  getApiUrl() {
     return this.config.apiUrl;
    
  }
  getConfig(parameter: string) {
    return this.config[parameter];
  }
  getAzureConfig() {

    return {
      tenant: this.config.azureAd.tenant,
      clientId: this.config.azureAd.clientId,
      endpoints: this.config.azureAd.endpoints,
      redirectUri: `${this.config.apiBaseUrl}`,//`${environment.hostname}/`,
      postLogoutRedirectUri: `${this.config.apiBaseUrl}`
    }
  }
  load() {

    // return new Promise((resolve) => {
    //   this.http.get<FrontEndConfig>('api/lookup/frontend-configuration')
    //     .pipe(map(res => res))
    //     .subscribe((responseData) => {
    //       this.config = responseData;
    //       resolve(true);
    //     });
    // });
  }
}
